module.exports = __webpack_public_path__ + "static/media/AvenirNext-Heavy.32c6584c.woff";